import React from 'react';

import {
  DateField,
  Labeled,
  TextField,
  usePermissions,
} from 'react-admin';

import {
  Box,
  Card,
  CardHeader,
  Grid,
  CardContent,
  Divider,
} from '@mui/material';

import EditField from '../../../../customFields/EditField';
import hasAccess from '../../../../utilities/hasAccess';
import PerformKyc from '../../../../customFields/PerformKyc';
import RiskManagement from '../../../riskManagment';
import actions, { Actions } from '../../../../constants/actions';
import EditArrayInput from '../../../../customFields/EditArrayInput';

const General = () => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Grid
      size={{
        xs: 12,
        lg: 5,
      }}
    >
      <Card variant="outlined">
        <CardHeader
          title="Car details"
          action={
            hasAccess(permissions, actions.REQUEST_CREATE) && (<PerformKyc />)
          }
        />
        <Divider />
        <CardContent>
          <Grid container spacing={2}>
            <Grid size={12}>
              <Box>
                <Labeled label="ID">
                  <TextField source="id" label="ID" />
                </Labeled>
              </Box>
            </Grid>
            <Grid size={12}>
              <Box>
                <Labeled label="Created at">
                  <DateField source="createdAt" />
                </Labeled>
              </Box>
            </Grid>
            <Grid size={12}>
              <EditArrayInput showEdit={hasAccess(permissions, actions.CAR_UPDATE)} source="customIds" label="Custom IDs" />
            </Grid>
            <Grid size={12}>
              <EditField showEdit={hasAccess(permissions, actions.CAR_UPDATE)} source="registrationNumber" label="Registration number" />
            </Grid>
            <Grid size={12}>
              <EditField showEdit={hasAccess(permissions, actions.CAR_UPDATE)} source="registrationCountry" label="Registration country" />
            </Grid>
            <Grid size={12}>
              <EditField showEdit={hasAccess(permissions, actions.CAR_UPDATE)} source="vinCode" label="Win code" />
            </Grid>
            <Grid size={12}>
              <EditField showEdit={hasAccess(permissions, actions.CAR_UPDATE)} source="carModel" label="model" />
            </Grid>
            <Grid size={12}>
              <EditField showEdit={hasAccess(permissions, actions.CAR_UPDATE)} type="date" source="kycApprovedAt" label="KYC approved" />
            </Grid>
            <Grid size={12}>
              <RiskManagement />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default General;
